export const agentsListArray = [
  {
    id: 1,
    agentPriority: 'PRIMARY',
    agentName: 'Cancun Handling Service',
    tel1: '+52 998 882 0101',
    tel2: '+52 998 882 0102',
    frequency: '127.2',
    email: 'ops@cunhandling.com',
  },
  {
    id: 2,
    agentPriority: 'ALTERNATE',
    agentName: 'Cancun Handling Service',
    tel1: '+52 998 882 0101',
    tel2: '+52 998 882 0102',
    frequency: '127.2',
    email: 'ops@cunhandling.com',
  },
  {
    id: 3,
    agentPriority: 'ALTERNATE',
    agentName: 'Cancun Handling Service',
    tel1: '+52 998 882 0101',
    tel2: '+52 998 882 0102',
    frequency: '127.2',
    email: 'ops@cunhandling.com',
  },
];

export const agentsHeadersArray = [
  { title: 'Agent Priority', field: 'agentPriority' },
  { title: 'Agent Name', field: 'agentName' },
  { title: 'Tel 1', field: 'tel1' },
  { title: 'Tel 2', field: 'tel2' },
  { title: 'Frequency', field: 'frequency' },
  { title: 'Email', field: 'email' },
];

export const agentPriority = [
  { itemValue: 'PRIMARY', itemLabel: 'PRIMARY' },
  { itemValue: 'ALTERNATE', itemLabel: 'ALTERNATE' },
];
